export default "__VITE_ASSET__BBuxkL0h__"